import { useTranslation } from "react-i18next";
import SectionHeader from "../../../util/component/SectionHeader";
import { Route, Routes } from "react-router-dom";
import React from "react";
import PayableInvoices from "./payableinvoices/sections/PayableInvoices";
import PayableInvoicePreview from "./payableinvoices/sections/PayableInvoicePreview";
import { useHasScope } from "../../../config/globalConfig";

const PagePayableInvoices = () => {
    const { t } = useTranslation('finance', { keyPrefix: 'payable-invoices' });
    const hasScope = useHasScope;
    return (
        <Routes>
            <Route path="/" element={
                <>
                    <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')}/>
                    <PayableInvoices/>
                </>
            }/>
            <Route path="/:id/*" element={
                <>
                    <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')}/>
                    <PayableInvoicePreview/>
                </>
            }/>
        </Routes>
    );
}

export default PagePayableInvoices;